import { render, staticRenderFns } from "./CardsTopInformacoes.vue?vue&type=template&id=fab19744&scoped=true&"
import script from "./CardsTopInformacoes.vue?vue&type=script&lang=js&"
export * from "./CardsTopInformacoes.vue?vue&type=script&lang=js&"
import style0 from "./CardsTopInformacoes.vue?vue&type=style&index=0&id=fab19744&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab19744",
  null
  
)

export default component.exports